import http from "../../http";

const userLabel = {
    selectUserLabelPage(param) {
        return http.spin.get("/gateway/api/lfuser/userLabel/selectUserLabelPage", param)
    },
    saveUserLabelConfig(param) {
        return http.confirm.payload("/gateway/api/lfuser/userLabel/saveUserLabelConfig", param)
    },
    queryUserLabelConfig(param) {
        return http.spin.get("/gateway/api/lfuser/userLabel/queryUserLabelConfig", param)
    },
    countUserLabelByCode(param) {
        return http.spin.get("/gateway/api/lfuser/userLabel/countUserLabelByCode", param)
    },
    deleteUserLabelConfig(param) {
        return http.confirm.tip.post("/gateway/api/lfuser/userLabel/deleteUserLabelConfig", param)
    },
    addMessageBatch(param) {
        return http.payload("/gateway/api/lfuser/userLabel/addMessageBatch", param)
    },
    sendMessagePre(param) {
        return http.spin.get("/gateway/api/lfuser/userLabel/sendMessagePre", param)
    },
    deleteMessageBatch(param) {
        return http.post("/gateway/api/lfuser/userLabel/deleteMessageBatch", param)
    },
    sendMessageByBatchId(param) {
        return http.post("/gateway/api/lfuser/userLabel/sendMessageByBatchId?batchId="+ param)
    },
    getLabelType() {
        return http.get("/gateway/api/lfuser/userLabel/getLabelType")
    },
    checkUserLabel(param) {
        return http.get("/gateway/api/lfuser/userLabel/checkUserLabel", param)
    },
    removeUserLabel(param) {
        return http.post("/gateway/api/lfuser/userLabel/removeUserLabel", param)
    },
    addUserLabel(param) {
        return http.post("/gateway/api/lfuser/userLabel/addUserLabel", param)
    },

    
    
    
}
export default userLabel

